export const delayUntilIdle = callback => {
  if (window.requestIdleCallback) {
    const callbackId = window.requestIdleCallback(callback, {
      timeout: 5000
    });
    return () => window.cancelIdleCallback(callbackId);
  }
  const timeoutId = window.setTimeout(callback, 0);
  return () => window.clearTimeout(timeoutId);
};